import React from 'react'

import CheckInputRound from '@web/components/CheckInputRound/CheckInputRound'
import Clickable from '@web/components/Clickable'
import links from '@web/libs/constants/links'
import nClicks from '@web/libs/nlog/click/codes'
import sendClickLog from '@web/libs/nlog/click/sendClickLog'

import styles from './index.module.scss'

const policyContents = (
  <>
    영수증 수집 및 이용에 대한 동의
    <br />
    <br />
    네이버(주)는 이용자가 제공한 영수증 이미지(영수증 내 구매 내역 및 구매 장소 등 포함)를 네이버 서비스 개선과 인공지능
    분야 기술 등의 연구개발 목적으로만 사용합니다. 서비스 개선과 발전에 도움을 주신 분들께 감사의 마음을 담아 이용
    약관에 따라 소정의 네이버 페이 포인트를 지급해 드리고 있습니다. 정보주체는 영수증 수집 및 이용에 관한 동의를
    거부하실 수 있으나, 이 경우 서비스 참여에 제한이 있을 수 있습니다.
    <br />
    <br />
    1. 수집하는 항목
    <br />
    - 영수증 이미지 파일에 포함된 정보
    <br />
    <br />
    2. 영수증 수집 및 이용목적
    <br />
    - 영수증 업로드 및 리뷰 작성 등 MY플레이스 서비스 이용
    <br />
    - 네이버㈜의 서비스 개선 및 신규 서비스 개발, 인공지능 기술 등의 연구개발
    <br />
    - 지인 및 관심사 등에 기반한 맞춤형 서비스 및 콘텐츠(광고 포함) 제공
    <br />
    - 서비스 부정이용 방지, 통계분석
    <br />
    <br />
    3. 영수증 이용 및 보유기간
    <br />- 영수증 이미지는 별도의 삭제 없이 연구개발 목적을 위해 보관합니다.
  </>
)

interface Props {
  agree: boolean
  onChangeAgree: (agree: boolean) => void
}
const Policy = ({ agree, onChangeAgree }: Props) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked
    sendClickLog({ event: e, area: checked ? nClicks.apply.RECEIPTOK : nClicks.apply.RECEIPTNO })
    onChangeAgree?.(checked)
  }

  return (
    <div className={styles.content_area}>
      <div className={styles.content_tit_area}>리뷰작성을 위해 동의가 필요합니다.</div>
      <div className={styles.terms_area}>
        <div className={styles.txt_area}>영수증 인증 및 리뷰 작성은 네이버 실명확인 계정으로만 이용 가능합니다.</div>
        <div className={styles.txt_area}>
          영수증 인증 및 리뷰 작성을 하기 위해서는 네이버페이 이용약관 및 &apos;영수증 수집 및 이용 동의&apos;에 대한
          최초 1회 동의가 필요합니다.
        </div>
        <div className={styles.txt_area}>
          자세한 이용 정책은{' '}
          <Clickable href={links.MYPLACE_POLICY} className={styles.link}>
            플레이스 리뷰 이용정책
          </Clickable>
          을 확인해주세요.
        </div>
        <div className={styles.requried_area}>
          <div className={styles.tit_area}>
            <input
              type="checkbox"
              id="agreeInfo"
              className={styles.input_checkbox}
              checked={agree}
              onChange={handleChange}
            />
            <label htmlFor="agreeInfo" className={styles.input_label}>
              <em>영수증 수집 및 이용 동의</em>
              &nbsp;(필수)
              <CheckInputRound checked={agree} className={styles.icon_wrapper} />
            </label>
          </div>
          <div className={styles.policy_area}>{policyContents}</div>
        </div>
      </div>
    </div>
  )
}

export default Policy
